module.exports = __webpack_public_path__ + "img/Kbus02_R_home slider.20a6a6a5.jpg";